import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './trust-safety.css'

const TrustSafety = (props) => {
  return (
    <div className="trust-safety-container1">
      <Helmet>
        <title>Trust-Safety - BidWally</title>
        <meta
          property="og:title"
          content="Trust-Safety - BidWally"
        />
        <link
          rel="canonical"
          href="https://bidwally.com/trust-safety"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-safety-mission">
        <div className="hero-safety-mission__bg">
          <video
            autoPlay="true"
            muted="true"
            loop="true"
            playsInline="true"
            poster="https://images.pexels.com/videos/3129576/pictures/preview-0.jpg"
            src="https://videos.pexels.com/video-files/3129576/3129576-hd_1280_720_30fps.mp4"
            className="hero-safety-mission__video"
          ></video>
          <div className="hero-safety-mission__overlay"></div>
        </div>
        <div className="hero-safety-mission__container">
          <div className="hero-safety-mission__content">
            <h1 className="hero-title">Trust &amp; Safety at BidWally</h1>
            <p className="hero-subtitle">
              Our mission is to create the world&apos;s most secure peer-to-peer
              crypto marketplace. We leverage a non-custodial model to ensure
              you remain in control of your assets while providing the tools to
              trade with confidence.
            </p>
            <div className="hero-safety-mission__actions">
              <a href="#report">
                <div className="btn btn-accent">
                  <span>Report an Issue</span>
                </div>
              </a>
              <a href="#verify">
                <div className="btn btn-primary">
                  <span>Verify Your Profile</span>
                </div>
              </a>
              <a href="#tips">
                <div className="btn btn-outline">
                  <span>Safety Tips</span>
                </div>
              </a>
            </div>
            <div className="hero-safety-mission__badge">
              <div className="hero-safety-mission__badge-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <span>Non-Custodial Security Protocol Active</span>
            </div>
          </div>
        </div>
      </section>
      <section className="community-guidelines">
        <div className="community-guidelines__container">
          <h2 className="section-title">Community Guidelines &amp; Policies</h2>
          <p className="section-subtitle">
            The foundation of a trustworthy marketplace is a clear set of rules.
            Here is how we maintain a safe environment for all users.
          </p>
          <div className="community-guidelines__accordion">
            <details className="community-guidelines__item">
              <summary className="community-guidelines__trigger">
                <span className="community-guidelines__label">
                  Acceptable Listings &amp; Prohibited Items
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="community-guidelines__icon"
                >
                  <path d="m6 9 6 6 6-6"></path>
                </svg>
              </summary>
              <div className="community-guidelines__content">
                <p className="section-content">
                  BidWally is a marketplace for legal goods and services. We
                  strictly prohibit the listing of illegal substances, weapons,
                  counterfeit items, or any financial instruments. Sellers are
                  responsible for ensuring their listings comply with local laws
                  and our global safety standards.
                </p>
              </div>
            </details>
            <details className="community-guidelines__item">
              <summary className="community-guidelines__trigger">
                <span className="community-guidelines__label">
                  Dispute Resolution Process
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="community-guidelines__icon"
                >
                  <path d="m6 9 6 6 6-6"></path>
                </svg>
              </summary>
              <div className="community-guidelines__content">
                <p className="section-content">
                  As a non-custodial marketplace, BidWally does not hold funds.
                  In case of a dispute, our moderation team acts as a mediator
                  to review communication logs and evidence. While we cannot
                  reverse blockchain transactions, we can take enforcement
                  actions against bad actors to protect the community.
                </p>
              </div>
            </details>
            <details className="community-guidelines__item">
              <summary className="community-guidelines__trigger">
                <span className="community-guidelines__label">
                  Enforcement Actions &amp; Appeals
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="community-guidelines__icon"
                >
                  <path d="m6 9 6 6 6-6"></path>
                </svg>
              </summary>
              <div className="community-guidelines__content">
                <p className="section-content">
                  Violations may result in listing removal, account suspension,
                  or permanent banning. Users who believe an action was taken in
                  error can submit an appeal through our Trust &amp; Safety
                  portal with supporting documentation for a secondary review by
                  senior moderators.
                </p>
              </div>
            </details>
          </div>
        </div>
      </section>
      <section className="payment-process">
        <div className="payment-process__container">
          <div className="payment-process__header">
            <h2 className="section-title">How P2P Payments Work</h2>
            <p className="section-subtitle">
              Understanding the non-custodial transaction flow and our security
              roadmap.
            </p>
          </div>
          <div className="payment-process__steps">
            <div className="payment-process__step">
              <div className="payment-process__number">
                <span>01</span>
              </div>
              <div className="payment-process__info">
                <h3 className="payment-process__name">
                  Direct Wallet-to-Wallet
                </h3>
                <p className="section-content">
                  Buyers send crypto directly from their personal wallet to the
                  seller&apos;s address. BidWally never touches your private
                  keys or your funds, significantly reducing platform-wide hack
                  risks.
                </p>
              </div>
            </div>
            <div className="payment-process__step">
              <div className="payment-process__number">
                <span>02</span>
              </div>
              <div className="payment-process__info">
                <h3 className="payment-process__name">
                  Transaction Verification
                </h3>
                <p className="section-content">
                  Once the transaction is broadcast to the blockchain, BidWally
                  monitors the network for confirmations. Sellers are notified
                  immediately once the payment is verified on-chain.
                </p>
              </div>
            </div>
            <div className="payment-process__step">
              <div className="payment-process__number">
                <span>03</span>
              </div>
              <div className="payment-process__info">
                <h3 className="payment-process__name">Escrow Roadmap</h3>
                <p className="section-content">
                  We are currently developing a smart-contract-based escrow
                  system. This will allow for automated trustless mediation,
                  further securing high-value transactions without centralizing
                  control.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="trust---safety-safety-features">
        <div className="safety-features__container">
          <h2 className="section-title">Safety Tips &amp; Precautions</h2>
          <p className="section-subtitle">
            Practical advice for secure local meetups and digital crypto trades.
          </p>
          <div className="trust---safety-safety-features__grid">
            <div className="trust---safety-safety-features__card">
              <div className="safety-features__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
              <h3 className="safety-features__name">Safe Meetup Locations</h3>
              <p className="section-content">
                Always meet in public, well-lit areas with surveillance, such as
                bank lobbies or police station &quot;safe zones&quot; for local
                trades.
              </p>
            </div>
            <div className="trust---safety-safety-features__card">
              <div className="safety-features__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"></path>
                </svg>
              </div>
              <h3 className="safety-features__name">Verification Checklist</h3>
              <p className="section-content">
                Check the seller&apos;s verification badge and reputation score.
                Verified profiles have linked social accounts or identity
                proofs.
              </p>
            </div>
            <div className="trust---safety-safety-features__card">
              <div className="safety-features__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="m21.73 18l-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3M12 9v4m0 4h.01"></path>
                </svg>
              </div>
              <h3 className="safety-features__name">Red Flag Alerts</h3>
              <p className="section-content">
                Beware of &quot;too good to be true&quot; prices, requests to
                move chat off-platform, or pressure to skip blockchain
                confirmations.
              </p>
            </div>
            <div className="trust---safety-safety-features__card">
              <div className="safety-features__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"></path>
                </svg>
              </div>
              <h3 className="safety-features__name">Digital Precautions</h3>
              <p className="section-content">
                Double-check wallet addresses. Use small test transactions for
                large trades and never share your seed phrase with anyone.
              </p>
            </div>
            <div className="trust---safety-safety-features__card">
              <div className="safety-features__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="m22 10-3 3 3 3"></path>
                </svg>
              </div>
              <h3 className="safety-features__name">Inspect Before Paying</h3>
              <p className="section-content">
                For physical goods, thoroughly inspect the item before
                initiating the crypto transfer. Once sent, crypto is
                non-reversible.
              </p>
            </div>
            <div className="trust---safety-safety-features__card">
              <div className="safety-features__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l2.19-2.19a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </div>
              <h3 className="safety-features__name">Emergency Contact</h3>
              <p className="section-content">
                If you feel unsafe during a local trade, leave immediately.
                Report the user via the app so we can flag their profile for
                others.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="scam-showcase">
        <div className="scam-showcase__container">
          <h2 className="section-title">Recognizing Scams &amp; Flags</h2>
          <p className="section-subtitle">
            Real examples of common fraudulent behavior and how our community
            identifies them.
          </p>
          <div className="scam-showcase__grid">
            <div className="scam-showcase__item">
              <div className="scam-showcase__image-wrapper">
                <img
                  src="https://images.pexels.com/photos/5475786/pexels-photo-5475786.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Phishing Attempt Example"
                  className="scam-showcase__image"
                />
                <div className="scam-showcase__flag">
                  <span>SCAM ATTEMPT</span>
                </div>
              </div>
              <div className="scam-showcase__info">
                <h3 className="scam-showcase__name">Phishing Links</h3>
                <p className="section-content">
                  Sellers sending external links to &quot;verify shipping&quot;
                  or &quot;escrow services.&quot; These are designed to steal
                  your wallet credentials.
                </p>
              </div>
            </div>
            <div className="scam-showcase__item">
              <div className="scam-showcase__image-wrapper">
                <img
                  src="https://images.pexels.com/photos/60504/security-protection-anti-virus-software-60504.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Fake Verification Label"
                  className="scam-showcase__image"
                />
                <div className="scam-showcase__flag">
                  <span>FLAGGED</span>
                </div>
              </div>
              <div className="scam-showcase__info">
                <h3 className="scam-showcase__name">Fake Verification</h3>
                <p className="section-content">
                  Users adding &quot;Verified&quot; text to their profile
                  images. Look for the official BidWally badge next to the
                  username instead.
                </p>
              </div>
            </div>
            <div className="scam-showcase__item">
              <div className="scam-showcase__image-wrapper">
                <img
                  src="https://images.pexels.com/photos/9577226/pexels-photo-9577226.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Payment Pressure"
                  className="scam-showcase__image"
                />
                <div className="scam-showcase__flag">
                  <span>WARNING</span>
                </div>
              </div>
              <div className="scam-showcase__info">
                <h3 className="scam-showcase__name">Advance Fee Scams</h3>
                <p className="section-content">
                  Requests for &quot;shipping deposits&quot; or
                  &quot;reservation fees&quot; before seeing the item. Never pay
                  anything upfront.
                </p>
              </div>
            </div>
            <div className="scam-showcase__item">
              <div className="scam-showcase__image-wrapper">
                <img
                  src="https://images.pexels.com/photos/30309058/pexels-photo-30309058.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Marketplace Manipulation"
                  className="scam-showcase__image"
                />
                <div className="scam-showcase__flag">
                  <span>COMMUNITY FLAG</span>
                </div>
              </div>
              <div className="scam-showcase__info">
                <h3 className="scam-showcase__name">Duplicate Listings</h3>
                <p className="section-content">
                  Multiple identical listings in different cities using the same
                  photos. Often used to cast a wide net for potential victims.
                </p>
              </div>
            </div>
            <div className="scam-showcase__item">
              <div className="scam-showcase__image-wrapper">
                <img
                  src="https://images.pexels.com/photos/30965500/pexels-photo-30965500.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Social Engineering"
                  className="scam-showcase__image"
                />
                <div className="scam-showcase__flag">
                  <span>CRITICAL</span>
                </div>
              </div>
              <div className="scam-showcase__info">
                <h3 className="scam-showcase__name">Support Impersonation</h3>
                <p className="section-content">
                  Users posing as BidWally Support in chat asking for wallet
                  keys. Official support will NEVER ask for your private data.
                </p>
              </div>
            </div>
            <div className="scam-showcase__item">
              <div className="scam-showcase__image-wrapper">
                <img
                  src="https://images.pexels.com/photos/7508683/pexels-photo-7508683.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Listing Indicators"
                  className="scam-showcase__image"
                />
                <div className="scam-showcase__flag">
                  <span>OBSERVED</span>
                </div>
              </div>
              <div className="scam-showcase__info">
                <h3 className="scam-showcase__name">Stock Photo Items</h3>
                <p className="section-content">
                  Listings using only manufacturer stock photos without any
                  real-world proof of possession. Always ask for a &quot;paper
                  tag&quot; photo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="reporting-workflow">
        <div className="reporting-workflow__container">
          <div className="reporting-workflow__header">
            <h2 className="section-title">How to Report an Issue</h2>
            <p className="section-subtitle">
              A clear guide on our reporting process and what to expect from our
              team.
            </p>
          </div>
          <div className="reporting-workflow__steps">
            <div className="reporting-workflow__step">
              <div className="reporting-workflow__number">
                <span>01</span>
              </div>
              <div className="reporting-workflow__info">
                <h3 className="reporting-workflow__name">Submit a Flag</h3>
                <p className="section-content">
                  Use the &quot;Report&quot; button on any listing or profile.
                  Select the appropriate category: Scam, Illegal Item,
                  Harassment, or Other.
                </p>
              </div>
            </div>
            <div className="reporting-workflow__step">
              <div className="reporting-workflow__number">
                <span>02</span>
              </div>
              <div className="reporting-workflow__info">
                <h3 className="reporting-workflow__name">Provide Evidence</h3>
                <p className="section-content">
                  Our team requires screenshots of chat logs, blockchain
                  transaction IDs, and any other relevant proof to take
                  definitive action.
                </p>
              </div>
            </div>
            <div className="reporting-workflow__step">
              <div className="reporting-workflow__number">
                <span>03</span>
              </div>
              <div className="reporting-workflow__info">
                <h3 className="reporting-workflow__name">Moderation Review</h3>
                <p className="section-content">
                  A human moderator reviews every report within 24 hours. We may
                  reach out for additional context before making a final
                  decision.
                </p>
              </div>
            </div>
            <div className="reporting-workflow__step">
              <div className="reporting-workflow__number">
                <span>04</span>
              </div>
              <div className="reporting-workflow__info">
                <h3 className="reporting-workflow__name">
                  Resolution &amp; Action
                </h3>
                <p className="section-content">
                  If verified, we remove the listing and suspend the account.
                  You will receive a notification regarding the outcome of your
                  report.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="transparency-stats">
        <div className="transparency-stats__container">
          <h2 className="section-title">Transparency &amp; Impact</h2>
          <p className="section-subtitle">
            Real-time metrics on our community safety initiatives and platform
            health.
          </p>
          <div className="transparency-stats__grid">
            <div className="transparency-stats__card">
              <div className="transparency-stats__value">
                <span>94%</span>
              </div>
              <p className="transparency-stats__label">Verified Seller Rate</p>
            </div>
            <div className="transparency-stats__card">
              <div className="transparency-stats__value">
                <span>&lt; 4h</span>
              </div>
              <p className="transparency-stats__label">Avg. Response Time</p>
            </div>
            <div className="transparency-stats__card">
              <div className="transparency-stats__value">
                <span>12k+</span>
              </div>
              <p className="transparency-stats__label">
                Flagged Listings Removed
              </p>
            </div>
            <div className="transparency-stats__card">
              <div className="transparency-stats__value">
                <span>8.5k</span>
              </div>
              <p className="transparency-stats__label">Disputes Mediated</p>
            </div>
            <div className="transparency-stats__card">
              <div className="transparency-stats__value">
                <span>99.8%</span>
              </div>
              <p className="transparency-stats__label">Platform Uptime</p>
            </div>
            <div className="transparency-stats__card">
              <div className="transparency-stats__value">
                <span>24/7</span>
              </div>
              <p className="transparency-stats__label">Human Moderation</p>
            </div>
          </div>
        </div>
      </section>
      <section className="safety-cta">
        <div className="safety-cta__container">
          <div className="safety-cta__grid">
            <div className="safety-cta__column">
              <div className="safety-cta__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="m16 11l2 2l4-4m-6 12v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="safety-cta__title">Become a Verified Seller</h3>
              <p className="section-content">
                Boost your reputation and build instant trust with potential
                buyers by completing our verification process.
              </p>
              <a href="#">
                <div className="btn btn-primary">
                  <span>Start Verification</span>
                </div>
              </a>
            </div>
            <div className="safety-cta__column">
              <div className="safety-cta__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"></path>
                  <path d="m9 12 2 2 4-4"></path>
                </svg>
              </div>
              <h3 className="safety-cta__title">Join Escrow Beta</h3>
              <p className="section-content">
                Help us shape the future of secure crypto trading. Apply for
                early access to our smart-contract escrow system.
              </p>
              <a href="#">
                <div className="btn btn-secondary">
                  <span>Apply for Beta</span>
                </div>
              </a>
            </div>
            <div className="safety-cta__column">
              <div className="safety-cta__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <h3 className="safety-cta__title">Community Shield</h3>
              <p className="section-content">
                Passionate about marketplace safety? Join our volunteer
                community flaggers and help protect your local area.
              </p>
              <a href="#">
                <div className="btn btn-accent">
                  <span>Join Initiative</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="trust-safety-container2">
        <div className="trust-safety-container3">
          <Script
            html={`<script defer data-name="safety-interactions">
(function(){
  // Simple interaction for accordion icons - native details handles the state
  // This just adds a little extra robustness if needed
  const detailsElements = document.querySelectorAll('details');
  
  detailsElements.forEach((details) => {
    details.addEventListener('toggle', () => {
      if (details.open) {
        // Close others if we wanted a single-open accordion
        // detailsElements.forEach(d => { if (d !== details) d.open = false; });
      }
    });
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default TrustSafety
